import React, { useState } from 'react';
import { LocaleContext } from './LocaleContext';

export type LocaleType = 'is' | 'en' | 'pl';

export const isLocaleType = (locale: string): locale is LocaleType => {
  return locale === 'is' || locale === 'en' || locale === 'pl';
};

interface IProps {
  initialLocale?: LocaleType;
}

export const Locale: React.FC<IProps> = ({
  children,
  initialLocale = 'is',
}) => {
  const [locale, setLocale] = useState<LocaleType>(initialLocale);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
